"use client";

import { ScrollTrigger } from "@/utils/gsap";

const REFRESH_DEBOUNCE_MS = 200;

let pendingTimer: ReturnType<typeof setTimeout> | null = null;
let pendingCallbacks: Array<() => void> = [];

/**
 * Schedules a debounced ScrollTrigger.refresh() that respects
 * the isScrolling flag exposed by the ScrollManager.
 *
 * Multiple calls within REFRESH_DEBOUNCE_MS collapse into one refresh.
 * Any callbacks registered during the same window are invoked after the refresh.
 */
export const scheduleDebouncedRefresh = (onRefreshed?: () => void): void => {
  if (pendingTimer) {
    if (onRefreshed) pendingCallbacks.push(onRefreshed);
    return;
  }

  if (onRefreshed) pendingCallbacks.push(onRefreshed);

  pendingTimer = setTimeout(() => {
    pendingTimer = null;
    const callbacks = pendingCallbacks;
    pendingCallbacks = [];
    ScrollTrigger.refresh();
    callbacks.forEach((cb) => cb());
  }, REFRESH_DEBOUNCE_MS);
};

export const cancelPendingRefresh = (): void => {
  if (pendingTimer) {
    clearTimeout(pendingTimer);
    pendingTimer = null;
    pendingCallbacks = [];
  }
};
